    import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LookupService } from '../../../services/lookup.service';
import { LookupValueItem } from '../../../interfaces/lookup.interface';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import {
  NzFormControlComponent,
  NzFormDirective,
  NzFormItemComponent,
} from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { ButtonComponent } from '@ppl/ui';
import { CommonModule } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { UserService } from '../../../services/user.service';
import { BillingService } from '../../../services/billing.service';

@Component({
  selector: 'ppl-billing-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    NzAutocompleteModule,
    CommonModule,
    NzDatePickerModule,
  ],
  templateUrl: './billing-filter.component.html',
  styleUrl: './billing-filter.component.css',
})
export class BillingFilterComponent implements OnInit {
  @Input() filterFields: any[] = [];
  @Output() searchEvent = new EventEmitter<any>();
  statusList: LookupValueItem[] = [];
  pageId = '';
  tabId = '';
  programName!: string;
  batchIds: any[] = [];
  fileNames: any[] = [];
  filteredConsumers: any[] = [];
  filteredProviders: any[] = [];
  billingFilterForm!: FormGroup;
  pmpmOptions: LookupValueItem[] = [];

  loopback = [
    { val: '30 days' },
    { val: '60 days' },
    { val: '90 days' },
    { val: '120 days' },
    { val: '150 days' },
    { val: '180 days' },
  ];

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private lookupService: LookupService,
    private billingService: BillingService
  ) { }

  ngOnInit(): void {
    const formFields = this.filterFields.reduce((acc, f) => {
      if (f.show) {
        acc = { ...acc, [f.field]: [f.default ? f.default : null] };
      }
      return acc;
    }, {});
    this.billingFilterForm = this.fb.group(formFields);

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.statusList = this.lookupService.getLookupValue('claim_status_lkp');
    this.pmpmOptions = this.lookupService.getLookupValue('Yes_No');
    this.getDropdownValues();
  }

  getDropdownValues(){
    this.billingService.getServiceCodeRates(this.programName).subscribe((data:any)=>{
      this.batchIds = data?.batchMasterIds;
      this.fileNames = data?.billingBatchMasterFileName;
    })
  }

  onInput(e: Event, fieldName: string): void {
    const value = (e.target as HTMLInputElement).value;
    console.log('on inout-----', e, fieldName, value);
    // if (fieldName === 'consumer') {
    //   this.filteredConsumers = value ? this.consumers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    // }
  }

  search() {
    this.searchEvent.emit(this.billingFilterForm.value);
  }
}
